






































































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import AppButton from '@/modules/shared/components/AppButton'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import memberStore from '@/modules/member/member.store'
import requestLogin from '@/utils/requestLogin'
import { IdentityAPI } from '@/api/identity'
import ServerError from '@/utils/server_error'
import { TournamentAPI, TournamentState } from '@/api/tournament'
import { ensureTournamentVerification } from '@/utils/verification'
import { now } from '@/utils/time'

export enum AutomatedTournamentAction {
  ViewTournament = 'VIEW_TOURNAMENT',
  ViewRegistrationStatus = 'VIEW_REGISTRATION_STATUS',
  JoinTournament = 'JOIN_TOURNAMENT',
  ViewBracket = 'VIEW_BRACKET'
}
@Component({
  components: {
    AppButton
  }
})
export default class InstantMatchActionButtons extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  memberModule = getModule(memberStore, this.$store)

  actionLoading: boolean = false

  tickTimer: NodeJS.Timeout | null = null
  countdownTimeleft: string = ''
  now: number = 0

  /* Methods */
  async fetchJoinedTournamentTeam() {
    if (!this.tournament) return
    try {
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.tournament.tournamentId
      )
    } catch (err) {
      if (err instanceof ServerError) {
        if (err.getStatusCode() >= 400 && err.getStatusCode() < 500) {
          return
        }

        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Loading.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  async created() {
    this.tickTimer = setInterval(this.onTick, 500)
    await this.onTick()
  }

  beforeDestroy() {
    if (this.tickTimer) {
      clearInterval(this.tickTimer)
    }
  }

  async onTick() {
    this.now = now().getTime() / 1000

    if (!this.tournament) {
      return
    }

    if (
      this.tournament.state === TournamentState.Published &&
      this.now <= this.tournament.scheduleRegistrationStartTime
    ) {
      this.updateCountdown(this.tournament.scheduleRegistrationStartTime)
    } else if (
      this.tournament.state === TournamentState.WaitingForCheckIn &&
      this.tournament.tournamentCheckInEndTime
    ) {
      this.updateCountdown(this.tournament.tournamentCheckInEndTime)
    } else if (this.now <= this.tournament.scheduleRegistrationEndTime) {
      this.updateCountdown(this.tournament.scheduleRegistrationEndTime)
    }
  }

  updateCountdown(targerTime: number) {
    if (typeof targerTime !== 'number') {
      return
    }

    const timeLeft = Math.round(targerTime - this.now)

    if (timeLeft < 0) {
      this.countdownTimeleft = ''
      return
    }

    const hr = Math.floor(timeLeft / 60 / 60)
    const min = Math.floor(timeLeft / 60) - hr * 60
    const sec = timeLeft % 60

    this.countdownTimeleft = `${
      hr > 0 ? `${hr.toString().padStart(2, '0')}:` : ''
    }${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
  }

  setTournamentActionDialogVisible(visible: boolean = false) {
    this.tournamentModule.setTournamentActionDialogVisible(visible)
  }

  onTournamentSelected() {
    if (this.tournamentAction === AutomatedTournamentAction.ViewBracket) {
      this.tournamentModule.setAutomatedTournamentBracketDialogVisible(true)
      return
    }

    this.actionLoading = true

    requestLogin(async () => {
      if (
        !(await ensureTournamentVerification({
          tournament: this.tournament!,
          callback: this.onTournamentSelected
        }))
      ) {
        this.actionLoading = false
        return
      }

      await this.fetchJoinedTournamentTeam()

      // check joined automated tournament
      try {
        const res = await TournamentAPI.getMemberJoinedAutomatedTournament()
        if (
          res.data.payload!.isJoined &&
          res.data.payload!.tournamentId !== this.tournamentId
        ) {
          this.actionLoading = false
          this.$toast.error(
            this.$t(
              'InstantMatchActionButtons.JoinedAnotherInstantMatchAlready'
            )
          )
          await this.$router.push({
            name: 'InstantMatchDetails',
            params: {
              tournamentId: res.data.payload!.tournamentId
            }
          })
          return
        }
      } catch (err) {
        if (err instanceof ServerError) {
          this.$toast.error(err.getMessage())
        } else {
          this.$toast.error(this.$t('Loading.SystemErrorMessage'))
        }
        console.error(err)
      }

      this.setTournamentActionDialogVisible(true)
      this.actionLoading = false
    })
  }

  onRulesAndDetailSelected() {
    if (this.$vuetify.breakpoint.mobile) {
      this.tournamentModule.setAutomatedTournamentRuleDialogVisible(true)
    } else {
      if (this.$route.name === 'InstantMatchDetailsSummary') {
        this.$router.push({ name: 'InstantMatchDetails' })
      } else {
        this.$router.push({ name: 'InstantMatchDetailsSummary' })
      }
    }
  }

  /* Computed Properties */
  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get tournamentId() {
    if (!this.tournament) return ''
    return this.tournament.tournamentId
  }

  get tournamentTeam() {
    return this.tournamentModule.selectedTournamentTeam
  }

  get isOpenRegistration() {
    if (!this.tournament) return false
    return this.tournament.state === TournamentState.OpenRegistration
  }

  get isCountdownTimerDisplayable() {
    return (
      this.tournament &&
      (this.now <= this.tournament.scheduleRegistrationEndTime ||
        [TournamentState.Published, TournamentState.WaitingForCheckIn].includes(
          this.tournament.state
        ))
    )
  }

  get shouldStatusButtonVisible() {
    if (this.tournament!.state === TournamentState.WaitingForCheckIn)
      return false
    if (
      this.$route.name === 'Landing' ||
      this.$route.name === 'AutomatedTournament' ||
      [
        TournamentState.OpenRegistration,
        TournamentState.InProgress,
        TournamentState.Completed
      ].includes(this.tournament!.state) ||
      this.isUserJoinedTournament
    ) {
      return true
    }

    return false
  }

  get onRulesAndDetailPage() {
    return this.$route.name === 'InstantMatchDetailsSummary'
  }

  get isPendingOpen() {
    if (!this.tournament) return false
    return this.tournament.state === TournamentState.Published
  }

  get isWaitingForCheckIn() {
    if (!this.tournament) return false
    return this.tournament.state === TournamentState.WaitingForCheckIn
  }

  get shouldDisplayStatusMessage() {
    return true // this.tournament!.state === TournamentState.WaitingForCheckIn
  }

  get statusMessageContent() {
    if (this.tournament!.state !== TournamentState.WaitingForCheckIn) return ''
    return this.$t('InstantMatchActionButtons.RegisteredTeamsCheckingIn')
  }

  get statusMessageIcon() {
    if (this.tournament!.state !== TournamentState.WaitingForCheckIn) return ''
    return 'mdi-alert-outline'
  }

  get tournamentAction(): AutomatedTournamentAction {
    if (
      this.tournament &&
      [TournamentState.InProgress, TournamentState.Completed].includes(
        this.tournament.state
      )
    )
      return AutomatedTournamentAction.ViewBracket
    else if (this.tournamentTeam)
      return AutomatedTournamentAction.ViewRegistrationStatus
    return AutomatedTournamentAction.JoinTournament
  }

  get tournamentActionString() {
    switch (this.tournamentAction) {
      case AutomatedTournamentAction.ViewTournament:
        return this.$t('TournamentBasicInformation.ViewTournament')

      case AutomatedTournamentAction.ViewRegistrationStatus:
        return this.$t('TournamentBasicInformation.ViewRegistrationStatus')

      case AutomatedTournamentAction.JoinTournament:
        return this.$t('TournamentBasicInformation.JoinTournament')

      case AutomatedTournamentAction.ViewBracket:
        return this.$t('TournamentBasicInformation.ViewBracket')
    }
  }

  get tournamentIconString() {
    switch (this.tournamentAction) {
      case AutomatedTournamentAction.ViewTournament:
        return 'mdi-eye'

      case AutomatedTournamentAction.ViewRegistrationStatus:
        return 'mdi-text-box'

      case AutomatedTournamentAction.JoinTournament:
        return 'mdi-account-multiple-plus-outline'

      case AutomatedTournamentAction.ViewBracket:
        return 'mdi-calendar-today'
    }
  }

  get isUserJoinedTournament() {
    return this.tournamentModule.joinedTournaments
      .map(tournament => tournament.tournamentId)
      .includes(this.tournamentId)
  }
}
